module.exports = __webpack_public_path__ + "static/media/权益四@2x.d12324bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_121/img/权益四@2x.png
// module id = 1139
// module chunks = 0